import * as yup from 'yup';

// Yup validation schema for leave form
export const leaveValidationSchema = yup.object({
  employee: yup.string().required('Employee is required'),
  leave_type: yup.string().required('Leave type is required'),
  start_date: yup.date().required('Start date is required').nullable().typeError('Invalid date format'),
  end_date: yup
    .date()
    .required('End date is required')
    .nullable()
    .typeError('Invalid date format')
    .min(yup.ref('start_date'), 'End date must be after start date'),
  reason: yup.string().trim().max(500, 'Reason must be less than 500 characters'),
  status: yup.string().required('Status is required'),
});

// Validation schema for leave settings
export const leaveSettingsValidationSchema = yup.object({
  employee: yup.string().required('Employee is required'),
  sick_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
  casual_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
  earned_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
  maternity_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
  paternity_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
  unpaid_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
  other_leaves_per_annum: yup
    .number()
    .min(0, 'Must be 0 or greater')
    .max(365, 'Cannot exceed 365 days')
    .typeError('Must be a number'),
});
